export const riskMapping = {
    'Very high vulnerability': {
        acronym: 'VHV',
        color: '#c27070',
    },
    'High vulnerability': {
        acronym: 'HV',
        color: '#d29292',
    },
    'Medium vulnerability': {
        acronym: 'MV',
        color: '#e9bf7a',
    },
    'Low vulnerability': {
        acronym: 'LV',
        color: '#6caa9c',
    },
    'No vulnerability': {
        acronym: 'NV',
        color: 'white',
    },
};
